import { render, staticRenderFns } from "./bloodOxygen.vue?vue&type=template&id=273570ba&scoped=true"
import script from "./bloodOxygen.vue?vue&type=script&lang=js"
export * from "./bloodOxygen.vue?vue&type=script&lang=js"
import style0 from "./bloodOxygen.vue?vue&type=style&index=0&id=273570ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273570ba",
  null
  
)

export default component.exports